export const HANDLE_LOCK_HINT = 'Аккаунт уже парсится — чтобы сменить ник или ссылку, заведите новый аккаунт';

export const lockedPrimaryPlatforms = (accounts) =>
  new Set((accounts ?? []).filter((a) => a?.isPrimary === true && a.handleLocked === true).map((a) => a.platform));

export const extraKey = (a) => `${a.platform}|${a.handle}`;

export const lockedExtraKeys = (accounts) =>
  new Set((accounts ?? []).filter((a) => a?.isPrimary !== true && a.handleLocked === true).map(extraKey));
